import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActionMenuComponent } from '../../../../shared/components/action-menu/action-menu.component';
import { ConfirmationModalComponent } from '../../../../shared/components/confirmation-modal/confirmation-modal.component';
import {
  DisplayQuestionModel,
  QuestionModel,
} from '../../../../shared/models/faq.model';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-topic-question',
  standalone: true,
  imports: [ConfirmationModalComponent, SharedModule, ActionMenuComponent],
  templateUrl: './topic-question.component.html',
  styleUrl: './topic-question.component.scss',
})
export class TopicQuestionComponent {
  @Output() onEdit: EventEmitter<number> = new EventEmitter<number>();
  @Output() onDelete: EventEmitter<number> = new EventEmitter<number>();
  @Input() set questions(value: QuestionModel[]) {
    this.allQuestions = value.map((el) => ({
      ...el,
      answer: this.domSantizer.bypassSecurityTrustHtml(el.answer),
    }));
    this.filteredQuestions = value.filter((question) =>
      question.question.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }
  @Input() reset = false;
  @Input() set search(value: string) {
    this.searchText = value;
    this.filteredQuestions = this.allQuestions.filter((question) =>
      question.question.toLowerCase().includes(value.toLowerCase())
    );
  }
  @Input() deleteLoading = false;
  get search() {
    return this.searchText;
  }

  private searchText = '';
  private allQuestions: DisplayQuestionModel[] = [];
  filteredQuestions: DisplayQuestionModel[] = [];

  deleteQuestionIndex: number = -1;

  selectedQuestionIndex = -1;
  menuOpenIndex = -1;
  constructor(private domSantizer: DomSanitizer) {}

  handleEdit(index: number) {
    this.onEdit.emit(index);
  }

  deleteQuestion() {
    this.onDelete.emit(this.deleteQuestionIndex);
    if (this.reset) {
      this.deleteQuestionIndex = -1;
    }
  }

  handleDelete(index: number) {
    if (index > -1) {
      this.deleteQuestionIndex = index;
    }
  }

  closeDeleteModal() {
    this.deleteQuestionIndex = -1;
  }
  toggleAccordian(index: number) {
    if (this.selectedQuestionIndex === index) {
      this.selectedQuestionIndex = -1;
    } else {
      this.selectedQuestionIndex = index;
    }
  }

  closeAllMenu(index: number) {
    if (index === this.menuOpenIndex) {
      this.menuOpenIndex = -1;
    }
  }
  handleMenuOpen(index: number) {
    this.menuOpenIndex = index;
  }

  openMenu(index: number) {
    if (this.menuOpenIndex === index) {
      this.menuOpenIndex = -1;
    } else {
      this.menuOpenIndex = index;
    }
  }
}
